export const TITLE_FONT_SIZE = 'tenant.css-variables-default.spotlight-title-font-size';
export const TITLE_FONT_WEIGHT = 'tenant.css-variables-default.spotlight-title-font-weight';
export const BUTTON_FONT_SIZE = 'tenant.css-variables-default.spotlight-button-font-size';
export const BUTTON_FONT_WEIGHT = 'tenant.css-variables-default.spotlight-button-font-weight';
export const CARD_FONT_SIZE = 'tenant.css-variables-default.spotlight-card-font-size';
export const CARD_FONT_WEIGHT = 'tenant.css-variables-default.spotlight-card-font-weight';
export const TEXT_OVERRIDES_KEY = 'tenant.spotlight.textOverrides';
export const TITLE_SUB_KEY = 'spotlight_main_title';
export const CARD_SUB_KEY = 'spotlight_counter_default_body';
export const SPOTLIGHT_ENABLE = 'tenant.spotlight.enabled';
export const SPOTLIGHT_TYPE = 'tenant.spotlight.type';
export const SPOTLIGHT_URL = 'tenant.spotlight.customUrl';
export const SPOTLIGHT_IS_SIDEBAR = 'tenant.spotlight.isSidebar';
export const spotlightConfigurations = [
  SPOTLIGHT_ENABLE,
  SPOTLIGHT_TYPE,
  SPOTLIGHT_URL,
  SPOTLIGHT_IS_SIDEBAR
];
